﻿$.fn.dxCtrlButtonImage = function custom_dxCtrlButtonImage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbuttonimage dx-ctrl");
        this.createInstance(new cdxCtrlButtonImage(this, option));
    }
    return this;
}

window.cdxCtrlButtonImage = function (container, option) {
    var Me = this;
    if (typeof option.fontSize == 'undefined') option.fontSize = 12
    if (typeof option.padding == 'undefined') option.padding = 8

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        var $Div = $("<i class='" + option.icon + " state-hover' style='border-radius:50%;padding:" + option.padding + "px;text-align:center;font-size:" + option.fontSize + "px;'></i>").appendTo(container)
        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            $Div.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Div, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }
        if (typeof option.onClick != 'undefined') {
            $Div.on("click", function (e) {
                e.element = Me.element()
                option.onClick(e)
            })
        }
    }

    this.element = function () { return container; }

    this.performClick = function () {
        option.onClick({
            component: dx,
            element: dx.element()
        })
    }

    mConstruit();
}